export function toIssueCardNumberFormat(value: number): string {
  return Number.isInteger(value) ? `${value}` : value.toFixed(2);
}
